// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__28E5M","content":"LoadingAlert_content__2fQf2"};